var _defs, _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoordash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#EB1700",
    x: "0px",
    y: "0px",
    viewBox: "19.58 19.58 40.84 40.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0.5,
    dy: 0.5,
    stdDeviation: 2,
    floodOpacity: 0.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    stroke: "none",
    fill: "#EB1700",
    rx: 19.8,
    height: 39.60546,
    width: 39.60546,
    y: 20.19727,
    x: 20.19727
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "dasherIcon",
    fill: "#EB1700",
    strokeOpacity: 0.15,
    rx: 20.4,
    height: 40.84314,
    width: 40.84314,
    y: 19.57843,
    x: 19.57843,
    filter: "url(#shadow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    stroke: "white",
    strokeWidth: 2,
    fill: "none",
    rx: 18.5,
    height: 37.13012,
    width: 37.13012,
    y: 21.43494,
    x: 21.43494
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "white",
    d: "m49.90136,40c0,-0.24086 -0.03515,-0.48059 -0.10433,-0.7113l-1.45971,-4.86528c-0.54964,-1.83237 -2.2361,-3.08712 -4.14904,-3.08712l-8.37656,0c-1.91294,0 -3.59939,1.25475 -4.14904,3.08712l-1.45971,4.86528c-0.06919,0.23071 -0.10434,0.47044 -0.10434,0.7113l0,7.67356c0,0.34654 0,0.51982 0.06745,0.65225c0.05929,0.11647 0.15397,0.21115 0.27043,0.27044c0.13243,0.06745 0.30571,0.06745 0.65225,0.06745l1.11391,0c0.34655,0 0.51982,0 0.65224,-0.06745c0.11647,-0.05928 0.21115,-0.15397 0.27044,-0.27044c0.06746,-0.13242 0.06746,-0.30571 0.06746,-0.65225l0,-1.48521l13.61438,0l0,1.48521c0,0.34654 0,0.51982 0.06746,0.65225c0.05928,0.11647 0.15397,0.21115 0.27043,0.27044c0.13243,0.06745 0.3057,0.06745 0.65225,0.06745l1.11391,0c0.34655,0 0.51982,0 0.65225,-0.06745c0.11647,-0.05928 0.21115,-0.15397 0.27044,-0.27044c0.06745,-0.13242 0.06745,-0.30571 0.06745,-0.65225l0,-7.67356zm-3.0323,-1.85651l-0.90263,-3.00878c-0.23553,-0.7853 -0.95833,-1.32307 -1.77816,-1.32307l-8.37656,0c-0.81983,0 -1.54263,0.53777 -1.77816,1.32307l-0.90263,3.00878l13.73814,0zm0.55695,4.02243c0,0.85448 -0.6926,1.54709 -1.54709,1.54709c-0.85448,0 -1.54709,-0.6926 -1.54709,-1.54709c0,-0.85448 0.6926,-1.54709 1.54709,-1.54709c0.85449,0 1.54709,0.6926 1.54709,1.54709zm-13.30496,1.54709c0.85448,0 1.54709,-0.6926 1.54709,-1.54709c0,-0.85448 -0.6926,-1.54709 -1.54709,-1.54709c-0.85449,0 -1.54709,0.6926 -1.54709,1.54709c0,0.85448 0.6926,1.54709 1.54709,1.54709z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoordash);
export default __webpack_public_path__ + "static/media/doordash.60606e4b532571226a1575d72bc27f92.svg";
export { ForwardRef as ReactComponent };